<template>
  <app-page :title="$t('@repaymentsList/title')" wide>
    <v-layout>
      <v-flex xs12>
        <v-subheader>
          {{ $t('@repaymentsList/repaymentFileListHeader') }}
        </v-subheader>
        <repayment-file-list ref="repayment-file-list" />

        <v-subheader>
          {{ $t('@repaymentsList/repaymentListHeader') }}
        </v-subheader>
        <repayment-list
          ref="repayment-list"
          @allSelected="(selected) => (allSelected = selected)"
          @itemsSelected="(ids) => (selectedIds = ids)"
        />

        <v-layout wrap>
          <v-flex xs12 class="layout justify-end pa-2">
            <v-tooltip left class="mr-2">
              <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on">info</v-icon>
              </template>
              <span>{{ $t('@repaymentsList/executionDateInfo') }}</span>
            </v-tooltip>

            <v-dialog
              ref="dialog"
              v-model="executionDateModal"
              :return-value.sync="executionDate"
              persistent
              lazy
              full-width
              width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="executionDate"
                :label="$t('@repaymentsList/executionDate')"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="executionDate"
                :min="minDate"
                :max="maxDate"
                type="date"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="executionDateModal = false">
                  {{ $t('@repaymentsList/cancel') }}
                </v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(executionDate)">
                  {{ $t('@repaymentsList/selectDate') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-btn color="primary" @click="createRepaymentFile" :disabled="!canCreateRepaymentFile">
              {{ $t('@repaymentsList/createRepaymentFile')
              }}{{
                this.selectedIds.length > 0
                  ? ` (${this.selectedIds.length} ${$t('@repaymentsList/numSelectedLabel')})`
                  : ''
              }}
            </v-btn>

            <v-btn color="" @click="selectAll" style="min-width: 160px;">
              {{
                allSelected ? $t('@repaymentsList/deselectAll') : $t('@repaymentsList/selectAll')
              }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </app-page>
</template>

<script>
import RepaymentFileList from './RepaymentFileList.vue';
import RepaymentList from './RepaymentList.vue';

export default {
  components: { RepaymentList, RepaymentFileList },
  data() {
    return {
      allSelected: false,
      selectedIds: [],
      date: null,
      dateModal: false,
      executionDate: '',
      executionDateModal: false,
      maxDate: '',
      minDate: '',
    };
  },

  mounted: function() {
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1);
    maxDate.setHours(0, 0, 0, 0);

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);
    minDate.setHours(0, 0, 0, 0);

    this.maxDate = maxDate.toISOString();
    this.minDate = minDate.toISOString();
  },

  computed: {
    canCreateRepaymentFile() {
      return this.selectedIds.length > 0 && this.executionDate != '';
    },
  },

  methods: {
    selectAll() {
      this.$refs['repayment-list'].selectAll();
    },

    async createRepaymentFile() {
      if (this.selectedIds.length === 0) {
        return;
      }

      await this.$http.post('/api/repayment-files', {
        repaymentIds: this.selectedIds,
        executionDate: this.executionDate,
      });

      this.$refs['repayment-list'].fetchData();
      this.$refs['repayment-file-list'].fetchData();
    },
  },
};
</script>

<style scoped>
.date-picker {
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-title {
  margin-right: 15px;
  color: inherit;
}
</style>
